/**
=========================================================
* Material Dashboard 2  React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const footer = (tooltipItems) => {
  let titleArray = [];
  if (typeof tooltipItems[1]?.raw === "number") {
    titleArray = tooltipItems[1].dataset.tooltipItems[
      tooltipItems[1].dataIndex
    ].map((item) => `${item.title} : ${item.value ?? "Not Updated"}`);
  }
  if (typeof tooltipItems[0]?.raw === "string") {
    titleArray = tooltipItems[0].dataset.tooltipItems[
      tooltipItems[0].dataIndex
    ].map((item) => `${item.title} : ${item.value ?? "Not Updated"}`);
  }
  return titleArray;
};

const beforeTitle = (tooltipItems) => {
  const quantitative = tooltipItems.filter(
    (el) => el.dataset.label === "Quantitative"
  );
  const qualitative = tooltipItems.filter(
    (el) => el.dataset.label === "Qualitative"
  );

  let titleArray = [];
  if (typeof qualitative[0]?.raw === "number") {
    titleArray = [
      `Monitoring Date: ${qualitative[0].label}`,
      `Monitoring Type: ${qualitative[0].dataset.label}`,
    ];
  }
  if (typeof quantitative[0]?.raw === "string") {
    titleArray = [
      `Monitoring Date: ${quantitative[0].label}`,
      `Monitoring Type: ${quantitative[0].dataset.label}`,
    ];
  }
  return titleArray;
};

function configs(labels, datasets) {
  return {
    data: {
      labels,
      datasets: datasets.map((dataset, index) => ({
        label: dataset.label,
        tension: 0.4,
        borderWidth: 0,
        borderRadius: 4,
        borderSkipped: false,
        backgroundColor: dataset.backgroundColor,
        data: dataset.data,
        maxBarThickness: 6,
        order: index, // Ensure correct stacking order for multiple datasets
        tooltipItems: dataset.quantitative || dataset.qualitative,
      })),
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          labels: {
            color: "#f8f9fa",
          },
        },
        tooltip: {
          label: false,
          callbacks: {
            footer: footer,
            title: beforeTitle,
            label: (item) => "", // it's disable the title
          },
        },
      },
      interaction: {
        intersect: false,
        mode: "index",
      },
      scales: {
        y: {
          min: 0,
          display: true,
          title: {
            display: true,
            text: "Height (m)",
            color: "#f8f9fa",
            font: {
              size: 14,
              weight: 300,
              family: "Roboto",
              style: "normal",
              lineHeight: 2,
            },
          },
          grid: {
            drawBorder: false,
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
            borderDash: [5, 5],
            color: "rgba(255, 255, 255, .2)",
          },
          ticks: {
            min: 0,
            stepSize: 10,
            suggestedMin: 0,
            suggestedMax: 500,
            beginAtZero: true,
            padding: 10,
            font: {
              size: 14,
              weight: 300,
              family: "Roboto",
              style: "normal",
              lineHeight: 2,
            },
            color: "#fff",
          },
        },
        x: {
          display: true,
          title: {
            display: true,
            text: "Monitoring Date",
            color: "#f8f9fa",
            font: {
              size: 14,
              weight: 300,
              family: "Roboto",
              style: "normal",
              lineHeight: 2,
            },
          },
          grid: {
            drawBorder: false,
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
            borderDash: [5, 5],
            color: "rgba(255, 255, 255, .2)",
          },
          ticks: {
            display: true,
            color: "#f8f9fa",
            padding: 10,
            font: {
              size: 14,
              weight: 300,
              family: "Roboto",
              style: "normal",
              lineHeight: 2,
            },
          },
        },
      },
    },
  };
}

export default configs;
